module.exports = __webpack_public_path__ + "img/tu2-1.901fe891.png";